function Svg() {
  this.processImages();
}

export default Svg.prototype.processImages = function() {

  var self = this;
  Array.from(document.querySelectorAll('img.svg')).forEach(function(imgSVG) {
    var imgDotSVG = imgSVG;
    var attr = {
      id: imgDotSVG.id,
      className: imgDotSVG.className,
      src: imgDotSVG.src.indexOf('.svg') > -1 ? imgDotSVG.src : imgDotSVG.getAttribute('data-src')
    };

    var getSVG = new XMLHttpRequest();
    getSVG.open('GET', attr.src, true);

    getSVG.onload = function() {
      if (this.status >= 200 && this.status < 400) {
        var data = this.response.toString();
        var emptyNode  = document.createElement('div');
        emptyNode.innerHTML = data;
        var svgImage = emptyNode.querySelector('svg');
        // Add replaced image's ID to the new SVG
        if (typeof attr.id !== 'undefined') {
          svgImage.id = attr.id;
        }
        // Add replaced image's classes to the new SVG
        if (typeof attr.className !== 'undefined') {
          var newClasses = attr.className.split(' ');
          newClasses.push('replaced-svg')
          svgImage.classList.add(newClasses);
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        svgImage.removeAttribute('xmlns:a');

        // Replace image with new SVG
        imgDotSVG.parentNode.replaceChild(svgImage, imgDotSVG);

        self.animateSVG();
      }
    };

    getSVG.send();
  });

};

Svg.prototype.animateSVG = function() {

  var pathsList = document.querySelectorAll(".line-to-draw:not(.animate), #Lines path:not(.animate)");

  var animatePath = function(path) {
    var length;

    if (path && !path.classList.contains("animate")) {
      length = path.getTotalLength();

      path.style.strokeDasharray = length + " " + length;
      path.style.strokeDashoffset = length;

      path.getBoundingClientRect();

      setTimeout(function() {
        path.classList.add("animate");
        path.style.strokeDashoffset = "0";
      }, 0);
    }
  };

  if (pathsList && pathsList.length) {
    for (var i = 0; i < pathsList.length; ++i) {
      animatePath(pathsList[i]);
    }
  }
};
